import * as ActionTypes from '../actionTypes';

const initialState = {
    isLoading: false,
    menuName: 'dashboard',
    searchKey: '',
    avatar: '',
    entityTypes: [
        'Sole Trader',
        'Partnership',
        'Joint Venture',
        'Trust',
        'Public Company',
        'Private Company',
        'Association',
        'Individual',
    ],
    states: {},
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.SET_MENU_NAME:
            return { ...state, ...{ menuName: action.payload, searchKey: '' } };
        case ActionTypes.SEARCH_KEY:
            return { ...state, ...{ searchKey: action.payload } };
        case ActionTypes.LOADING_ON:
            return { ...state, ...{ isLoading: true } };
        case ActionTypes.LOADING_OFF:
            return { ...state, ...{ isLoading: false } };
        case ActionTypes.LOADING_ALL_STATES:
            return { ...state, ...{ states: action.payload } };
        default:
            return state;
    }
}
